import React, { useEffect, useState,useRef } from 'react';
import { BrowserRouter as Router, Route, Link, useParams, useNavigate } from 'react-router-dom';
import { AxiosInstance } from './components/utils';
import "./css/bootstrap.min.css";
import "./css/animate.min.css";
import "./css/style.css";
import "./css/responsive.css";
import "./css/light-color.css";
import "./css/floatlabel.css";
import "./css/customstyle.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Banner } from './components/sections/banner';
import { HeaderNoMenu } from './components/sections/headernomenu';
import { AboutEvent } from './components/sections/aboutevent';
import { AdditionalSection } from './components/sections/additionalsection';
import { ScheduleSection } from './components/sections/schedulesection';
import { SpeakersSlider } from './components/sections/speakersslider';
import ScrollToTop from 'react-scroll-to-top';
import Registration from './components/sections/registration';
import { PricingPlan } from './components/sections/pricingplans';
import { SponsorSection } from './components/sections/sponsorsection';
import { PartnerSection } from './components/sections/partnersection';
import { ToastContainer, toast } from 'react-toastify';
import { TicketDetails } from './components/sections/ticketdetails';
import { LocationMap } from './components/sections/locationMap';
import { Contactus } from './components/sections/contactus';
import PosterCreator from './components/sections/postercreator';
function sleep(ms: any) {
    return new Promise(resolve => setTimeout(resolve, ms));
}


function EvtHub() {
    const [loading, setLoading] = useState(true);
    const [eventresp, setEventresp] = useState({} as any);
    const [ticketDetails, setTicketDetails] = useState(null as any);
    const ticketRef = useRef(null as any);
    const navigate = useNavigate();
    const { eventcode } = useParams();
    const queryParams = new URLSearchParams(window.location.search);
    const ticketkey = queryParams.get("ticketkey");
    const errmsg = queryParams.get("msg");
    
    
    useEffect(() => {
        if (eventcode == null) {
            navigate('/pagenotfound');
        }

        const fetchData = async () => {

            setLoading(true);

            const { data: response } = await AxiosInstance.get('/api/getevent?eventcode=' + eventcode);
           
            if (response.result != "Success" || response.data?.length == 0) {
                setLoading(false);
                navigate('/pagenotfound');
            }
            console.log('rendering eventhub with eventresp', response.data[0]);
            setLoading(false);
            setEventresp(response.data[0]);
        }

        const fetchTicketDetails = async () => {

            setLoading(true);
            const { data: response } = await AxiosInstance.get('/api/getticket?ticketkey=' + ticketkey);
            if (response.result != "Success") {
                setLoading(false);
                return;
            }
            setLoading(false);
            setTicketDetails(response.ticketdetails);
            console.log(ticketRef);
            if(ticketRef!=null && ticketRef.current !=null)
            {
                console.log(' start scrol ticket');
                ticketRef.current.scrollIntoView({  block: 'center' });
            }
        }


        fetchData();
        if(ticketkey != null && ticketkey != '')
        {
            fetchTicketDetails();
        }
    }, [navigate]);

    if(errmsg)
    {
        let msg = errmsg;
        if(errmsg=='PAYMENT_FAILED')
        {
            msg='Payment Failed. Please retry.';
            toast.error(msg);
        }
        else if(errmsg=='COUPONS_ALREADY_GENERATED')
        {
            msg='Coupons already sent to mail.';
            toast.error(msg);
        }
        else if(errmsg=='GROUP_PAY_SUCCESS')
        {
            msg='Payment Successful. Please check mail for further details.';
            toast(msg);
        }
    }
    if (loading) {
        return (<div id="preloader">
            <div id="status">
                <div className="spinner"></div>
            </div>
        </div>);
    }
    else {
        return (
            <>
{eventresp && <div className="antialiased light-vz circle-v ">
                <HeaderNoMenu />
            
                <PosterCreator templateUrl={eventresp.iamAttending?.imageUrl} eventcode={eventresp.eventcode} />

             

               


                

                <section className="doc-sec sec-padding">
                    <div className="container">
                        <div className="sec-title">
                            <span className="icon-inner wow flipInY" data-wow-duration="300ms"><span className="fa-stack"><i className="fa rhex fa-stack-2x"></i><i className="fa fa-ticket fa-stack-1x"></i></span></span>
                            <h3 className="wow fadeInRight" data-wow-duration="500ms">About BSides Bangalore <small>/ How to become a member</small></h3>
                        </div> {/* <!--sec-title end--> */}
                        <div className="doc-sec-details">
                            <p>Security BSides is a community-led framework for establishing events for and by information security community members across the globe. BSides Bangalore is a non-profit entity approved by BSides. It is driven and supported by cybersecurity community members across the globe. BSides Bangalore presents technical security talks, technical hands-on workshops, CTF, Pannel Discussions, CxO junction and other interesting knowledge gaining events on cutting edge security technologies, with the very latest security research, development and trends. More details can be found at <a href="https://bsidesbangalore.in" target="_blank">https://bsidesbangalore.in</a></p>
                            <p>You can become a member by visiting <a target="_blank" href="https://bsidesbangalore.in/registermember" >https://bsidesbangalore.in/registermember </a></p>
                        </div> {/* <!-- about-sec-details end--> */}
                    </div>
                </section> {/* <!--about-sec end--> */}
                <footer>
                    <div className="container">
                        <ul className="social-line list-inline">
                            <li className="wow flipInY" data-wow-duration="200ms"><a href="https://x.com/bsidesbangalore" className="twitter"><i className="fa fa-twitter"></i></a></li>
                            <li className="wow flipInY" data-wow-duration="300ms"><a href="https://www.youtube.com/channel/UC0SqOU2NDDIP0bbt5OwW8Hw" className="google"><i className="fa fa-youtube"></i></a></li>
                            <li className="wow flipInY" data-wow-duration="400ms"><a href="https://lnkd.in/gZ8N3Kxr" className="linkedin"><i className="fa fa-linkedin"></i></a></li>
                            <li className="wow flipInY" data-wow-duration="500ms"><a href="https://www.instagram.com/bsides_bangalore" className="instagram"><i className="fa fa-instagram"></i></a></li>
                        </ul>
                        <p>© 2025 BSides Bangalore</p>
                    </div>
                </footer>

                
                <ScrollToTop  component={<i className="fa fa-angle-up"></i>} smooth />
                <ToastContainer position="bottom-right"/>
                </div>}
            </>
        );
    }
}
export default EvtHub;
